<ng-container *ngIf="state">
    <div class="btr-ib-panel" role="group" [id]="panelId" [attr.aria-labelledby]="panelId + '_title'">
        <ds-icon class="btr-ib-panel__icon" name="warning" size="lg"></ds-icon>

        <div class="btr-ib-panel__content">
            <div class="btr-ib-panel__intro">
                <ds-text [id]="panelId + '_title'" size="sm" weight="semibold" theme="primary" text="Verify inbound reposition"></ds-text>
                <ds-text size="sm" weight="regular" theme="secondary" [text]="state.description"></ds-text>
            </div>

            <form class="btr-ib-panel__form" [formGroup]="form" (ngSubmit)="confirm()">
                <ds-input
                    [id]="panelId + '_hours'"
                    formControlName="verifiedHours"
                    label="IB repo hours *"
                    type="number"
                    min="0"
                    max="99.99"
                    placeholder="0.00"
                >
                    <span suffix>hrs</span>
                    <mat-error>Enter hours from 0 to 99.99, with 2 decimals or fewer.</mat-error>
                </ds-input>

                <ds-textarea
                    class="btr-ib-panel__form-note"
                    [id]="panelId + '_note'"
                    formControlName="note"
                    label="Note"
                    placeholder="Note (optional)"
                    [maxlength]="noteMaxLength"
                    [minRows]="2"
                    [maxRows]="4"
                >
                    <mat-hint>{{ noteCounter }}</mat-hint>
                    <mat-error>Enter {{ noteMaxLength }} characters or fewer.</mat-error>
                </ds-textarea>
            </form>

            <ng-container *ngIf="errorMessage">
                <p class="btr-ib-panel__error" role="alert">{{ errorMessage }}</p>
            </ng-container>

            <div class="btr-ib-panel__actions">
                <ds-button label="Cancel" theme="secondary-gray" [isDisabled]="isPending" (buttonClick)="cancelled.emit()"></ds-button>
                <ds-button label="Confirm hours" [isDisabled]="isInvalid" [isLoading]="isPending" (buttonClick)="confirm()"></ds-button>
            </div>
        </div>
    </div>
</ng-container>
